"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlComponentRendererProvider = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Webgl1/2 implementation of {@link IComponentRendererProvider}.
 */
class GlComponentRendererProvider {
    constructor() {
        this.cache = new Map();
    }
    getRenderer(graphicsComponent) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.cache.get(graphicsComponent.getCacheId());
    }
    initializeRenderer(graphicsComponent, create) {
        return rc_js_util_1._Map.initializeGet(this.cache, graphicsComponent.getCacheId(), create);
    }
    onContextLost() {
        this.cache.forEach((componentRenderer) => {
            componentRenderer.onContextLost();
        });
    }
    reinitializeRenderers(factory) {
        this.cache.forEach((renderer, key) => {
            this.cache.set(key, factory.createRenderer(renderer.specification));
        });
    }
}
exports.GlComponentRendererProvider = GlComponentRendererProvider;
//# sourceMappingURL=gl-component-renderer-provider.js.map